import { ENTITY_TYPES } from "src/website-apps/shared/components/grid/favorites-fs/constants";
import { getSearchGroupResults } from "./searchGroupShapes";

export const resolveInitialFavoritesState = (model) => {
  const performers = [...(getSearchGroupResults(model?.topSearchResults) ?? [])];
  // the eventsGrid model exposes two keys '0' and '2' which appear to map to
  // geo scoped and non-geo scoped events respectively, enumerating over the keys
  // to initialize the favorites state
  const events = Object.values(model?.eventGrids ?? {}).flatMap((payload) => payload?.items ?? []);
  const performerFavorites = performers.reduce((acc, curr) => {
    acc[ENTITY_TYPES.CATEGORY] ??= {};
    acc[ENTITY_TYPES.CATEGORY][curr.id] = curr.isFavorite;
    return acc;
  }, {});
  const eventFavorites = events.reduce((acc, curr) => {
    acc[ENTITY_TYPES.EVENT] ??= {};
    acc[ENTITY_TYPES.EVENT][curr.eventId] = curr.isFavorite;
    return acc;
  }, {});
  return {
    ...performerFavorites,
    ...eventFavorites,
  };
};
